module.exports = __webpack_public_path__ + "static/media/login.19e838b8.svg";